<span>
    <p style="margin-top: 25px;">
        <a onclick="smoothScroll(document.getElementById('gallery'))" (click)="addLogsNavInfo('gallery')"
            class="image-cruise facilities-a">Photos</a> &nbsp;|&nbsp;
        <a onclick="smoothScroll(document.getElementById('itinerary'))" (click)="addLogsNavInfo('itinerary')"
            class="image-cruise facilities-a">Itinerary</a> &nbsp;|&nbsp;
        <a onclick="smoothScroll(document.getElementById('includes'))" (click)="addLogsNavInfo('includes')"
            class="image-cruise facilities-a">Included</a> &nbsp;|&nbsp;
        <a onclick="smoothScroll(document.getElementById('noIncludes'))" (click)="addLogsNavInfo('noIncludes')"
            class="image-cruise facilities-a">Not Included</a> &nbsp;|&nbsp;
        <span *ngIf="isVisibleReview()">
            <a onclick="smoothScroll(document.getElementById('reviews'))" (click)="addLogsNavInfo('reviews')"
                class="image-cruise facilities-a">Reviews</a> &nbsp;|&nbsp;
        </span>
        <span *ngIf="activatedFaqs">
            <a onclick="smoothScroll(document.getElementById('faqs'))" (click)="addLogsNavInfo('faqs')"
                class="image-cruise facilities-a">FAQs</a> &nbsp;|&nbsp;
        </span>
        <!-- / NAV SECTION -->
        <!-- FACILITIES SECTION -->
    <h4 class="mt-4 mb-3 borderbottom" data-toggle="collapse" href="#coll0" role="button" aria-expanded="true"
        aria-controls="coll0" (click)="collapsedFacilities = !collapsedFacilities">Yacht Facilities
        <i class="fa fa-angle-up icon-angle" *ngIf="!collapsedFacilities"></i>
        <i class="fa fa-angle-down icon-angle" *ngIf="collapsedFacilities"></i>
    </h4>
    <div class="collapse show" [collapse]="!collapsedFacilities" [isAnimated]="true">
        <p class="text-justify">{{ boatInfo.description }}</p>
        <div class="row mt20">
            <div class="col-md-6">
                <div *ngFor="let c of amenities_one" class="cruise-facilities">
                    <img src="assets/icons/{{c}}.png" height="25" />
                    <span class="cruise-facilities-span">{{c}}</span>
                </div>
            </div>
            <div class="col-md-6">
                <div *ngFor="let c of amenities_two" class="cruise-facilities">
                    <img src="assets/icons/{{c}}.png" height="25" />
                    <span class="cruise-facilities-span">{{c}}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- / FACILITIES SECTION -->

    <!-- GALLERY SECTION -->
    <h4 id="gallery" class="mt-4 mb-3 borderbottom" (click)="collapsedGallery = !collapsedGallery"
        [attr.aria-expanded]="collapsedGallery" data-bs-toggle="collapse" role="button" aria-expanded="false">
        Photos
        <i class="fa fa-angle-up icon-angle" *ngIf="!collapsedGallery "></i>
        <i class="fa fa-angle-down icon-angle" *ngIf="collapsedGallery "></i>
    </h4>
    <div class="carousel slide carousel-fade" *ngIf="collapsedGallery">
        <div *ngIf="detailViewTemplate == 'center'">
            <app-cruise-information-picture-carousel [images]="galleryImage" class="carousel slide carousel-fade"
                *ngIf="collapsedGallery"></app-cruise-information-picture-carousel>
        </div>
        <div *ngIf="detailViewTemplate != 'center'">
            <div class="carousel-inner" role="listbox">
                <div class="carousel-item active">
                    <img [src]="pathCruisePhotos + galleryImage[currentImage]" height="auto" width="100%">
                </div>
            </div>
            <span class="carousel-control-prev" (click)="prev()" *ngIf="currentImage > 0">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            </span>
            <span class="carousel-control-next" (click)="next()" *ngIf="currentImage < boatInfo.images.length - 1">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
            </span>
            <ol class="carousel-indicators">
                <li *ngFor="let picture of galleryImage; let i = index" (click)="selectImage(i)">
                    <img class="d-block w-100 img-fluid" [src]="pathCruisePhotos + galleryImage[i]" height="100">
                </li>
            </ol>
        </div>
    </div>
    <!-- / GALLERY SECTION -->

    <!-- ITINERARIES SECTION -->
    <h4 id="itinerary" class="mt-4 mb-3 borderbottom" (click)="collapsedItinerary = !collapsedItinerary"
        [attr.aria-expanded]="collapsedItinerary" data-bs-toggle="collapse" role="button" aria-expanded="false">
        Itinerary
        <i class="fa fa-angle-up icon-angle" *ngIf="!collapsedItinerary"></i>
        <i class="fa fa-angle-down icon-angle" *ngIf="collapsedItinerary"></i>
    </h4>

    <div class="collapse show" [collapse]="!collapsedItinerary" [isAnimated]="true">

        <div class="carousel-inner" role="listbox">
            <img [src]="pathItinerary + imagesItinerary[currentItinerary]" height="auto" width="100%">
        </div>
        <div style="padding: 15px">
            <app-rating *ngIf="isVisibleRating()" size="small" name="Flora & Fauna"
                [rating]=itinerarySelected.floraFaunaRating></app-rating>
            <app-rating *ngIf="isVisibleRating()" size="small" name="Landscapes"
                [rating]=itinerarySelected.landscapesRating></app-rating>
            <app-rating *ngIf="isVisibleRating()" size="small" name="Activities"
                [rating]=itinerarySelected.activitiesRating></app-rating>
        </div>
        <app-itinerary-details [itineraries]="getItineraries()" [className]="'table-striped'"
            [isIncludeTableHeader]="true" [isWidthComplete]="true" [tourLengthShortName]="boatInfo.availability[0].name"
            [cruiseName]="boatInfo.name" [daysItinerary]="boatInfo.availability[0].length?.split('D', 1)?.[0]"
            [itineraryDescription]="getItineraryDescription()" [itineraryName]="boatInfo.availability[0].name.trim()">
        </app-itinerary-details>
        <p class="mt-3" style="text-align: justify; font-size: 12px;">{{itineraryDisclaimer}}</p>
    </div>
    <!-- / ITINERARIES SECTION -->

    <!-- INCLUDED SECTION -->
    <h4 id="includes" class="mt-4 mb-3 borderbottom" (click)="collapsedIncludes = !collapsedIncludes"
        [attr.aria-expanded]="collapsedIncludes" data-bs-toggle="collapse" role="button" aria-expanded="false">
        Included
        <i class="fa fa-angle-up icon-angle" *ngIf="collapsedIncludes"></i>
        <i class="fa fa-angle-down icon-angle" *ngIf="!collapsedIncludes"></i>
    </h4>
    <div class="collapse show" [collapse]="collapsedIncludes" [isAnimated]="true">
        <div *ngFor="let include of featureInclude">
            <li class="fa fa-check" [ngStyle]="{ 'color': '#'+this.companyParams.getMainColor() }">
            </li>
            {{include.name}}
        </div>
    </div>
    <!-- / INCLUDED SECTION -->

    <!-- NOT INCLUDED SECTION -->
    <h4 id="noIncludes" class="mt-4 mb-3 borderbottom" (click)="collapsedNoIncludes = !collapsedNoIncludes"
        [attr.aria-expanded]="!collapsedNoIncludes" data-bs-toggle="collapse" role="button" aria-expanded="false">
        Not Included
        <i class="fa fa-angle-up icon-angle" *ngIf="collapsedNoIncludes"></i>
        <i class="fa fa-angle-down icon-angle" *ngIf="!collapsedNoIncludes"></i>
    </h4>
    <div class="collapse show" [collapse]="collapsedNoIncludes" [isAnimated]="true">
        <div *ngFor="let noInclude of featureNoInclude" style="display: flex;">
            <li class="fa fa-times" aria-hidden="true" style="color: red;" style="padding-right: 4px;">
            </li> {{noInclude.name}}
        </div>
    </div>
    <!-- / NOT INCLUDED SECTION -->
    <!-- REVIEW SECTION -->
    <div *ngIf="isVisibleReview()">
        <h4 id="reviews" class="mt-4 mb-3 borderbottom" (click)="collapsedReviews = !collapsedReviews"
            [attr.aria-expanded]="!collapsedReviews">
            Reviews
            <i class="fa fa-angle-up icon-angle" *ngIf="collapsedReviews"></i>
            <i class="fa fa-angle-down icon-angle" *ngIf="!collapsedReviews"></i>
        </h4>
        <div class="collapse show" [collapse]="collapsedReviews" [isAnimated]="true">
            <div>
                <app-card-review *ngFor="let comment of boatInfo.comments" [comment]="comment"
                    style="width: 380px;"></app-card-review>
            </div>
        </div>
    </div>

    <!-- / REVIEW SECTION -->
    <!-- FABS -->
    <div class="faqs-section" *ngIf="activatedFaqs">
        <h4 id="faqs" class="mt-4 mb-3 borderbottom" (click)="collapsedFaqs = !collapsedFaqs"
            [attr.aria-expanded]="!collapsedNoIncludes" data-bs-toggle="collapse" role="button" aria-expanded="false">
            FAQS
            <i class="fa fa-angle-up icon-angle" *ngIf="!collapsedFaqs"></i>
            <i class="fa fa-angle-down icon-angle" *ngIf="collapsedFaqs"></i>
        </h4>
        <div *ngIf="collapsedFaqs" class="faq-content">
            <div *ngFor="let faq of boatInfo.faqs" class="faq-item">
                <div class="faq-question">
                    <span class="faq-question-prefix label-q"
                        [ngStyle]="{ 'color': '#' + companyParams.getSecundaryColor() }">Q: </span>
                    {{ faq.question }}
                </div>
                <div class="faq-answer">
                    <span class="label-a">A:</span> {{ faq.answer }}
                </div>
            </div>
        </div>
    </div>
    <!-- / FABS -->
</span>